<template>
  <div class="cash-withdrawal">
    <div class="tixian">
      <div class="jiangli_top" @click="$router.go(-1)">
        <img @click="fanhui()" src="../../../assets/images/licai/fanhui.png" />
        <p class="bt">提现</p>
      </div>
      <div class="tixian_price">
        <p class="tixian_price_num">{{ ktxje }}</p>
        <p class="trips">账户余额（元）</p>
      </div>
    </div>
    <div class="tixian_block">
      <p class=""></p>
      <div class="tixian_block_card" @click="backShow = true">
        <img style="width: 30px;" src="../../../assets/images/yhk/yhk.png" />
        <div class="tixian_block_card-flex">
          <p class="" style="font-size: 20px;color: #000;white-space: nowrap;">
            {{ currentBack.type }} （{{
              "****" + currentBack.card.substring(currentBack.card.length - 6)
            }}）
          </p>
          <p class="" style="font-size: 14px;color: #999;margin-top: 10px;">
            <!-- 提现后24小时到账 -->
          </p>
        </div>
        <div class="tixian_block_img">
          <img
            style="width: 20px;"
            src="../../../assets/images/licai/right.png"
          />
        </div>
      </div>
      <p class="" style="margin-top: 15px;"></p>
      <div class="tixian_shuru">
        <p class="">￥</p>
        <input
          type="number"
          v-model="money"
          class="tixian_input"
          placeholder=""
        />

      </div>
      <div class="tixian_trip">
        <p>可用余额 ￥{{ ktxje }}</p>
      </div>
    </div>
    <div class="tixian_buts" @click="passwordShow = true">
      <button>提交</button>
    </div>
    <van-popup
      v-model="backShow"
      position="bottom"
      :style="{ height: '55%', paddingTop: '10px', padding: '20px' }"
    >
      <!-- 密码输入框 -->
      <div class="zfmm title">请选择数字人民币</div>
      <div v-if="backList.length != 0">
        <div
          class="tixian_block_card carditem"
          v-for="(item, index) in backList"
          :key="index"
          @click="changeBank(item)"
        >
          <img style="width: 30px;" src="../../../assets/images/yhk/yhk.png" />

          <div class="" style="margin-left: 8px;">
            <p class="" style="font-size: 20px;color: #000;">
              {{ item.type }} （{{
                "****" + item.card.substring(item.card.length - 6)
              }}）
            </p>
            <p class="" style="font-size: 14px;color: #999;margin-top: 8px;">
              <!-- 提现后24小时到账 -->
            </p>
          </div>
          <div class="tixian_block_img">
            <img
              style="width: 20px;"
              src="../../../assets/images/licai/right.png"
            />
          </div>
        </div>
      </div>
      <div class="tixian_block_card carditem" v-else>
        <div class="">
          <p class="" style="font-size: 20px;color: #000;">绑定数字人民币</p>
          <p class="" style="font-size: 14px;color: #999;"></p>
        </div>
        <div class="tixian_block_img">
          <img
            style="width: 20px;"
            src="../../../assets/images/licai/right.png"
          />
        </div>
      </div>
    </van-popup>

    <van-dialog
      confirmButtonColor="#ff1900"
      v-model="passwordShow"
      title="请输入支付密码"
      show-cancel-button
      @confirm="pwdChange2"
      @cancel="pwd = ''"
      @close="pwd = ''"
    >
      <div class="zfmm">
        <van-field v-model="pwd" type="password" />
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { postCashInfo } from "../../../api/user";

import { bank_list, pay_withdraw } from "@api/pay";

export default {
  name: "UserCash",
  components: {},
  props: {},
  data: function() {
    return {
      currentBack: {},
      backList: [],
      backShow: false,
      passwordShow: false,
      pwd: "",
      money: "",
      cid: "",
      showKeyboard: true,

      navList: [
        {
          name: "数字人民币",
          type: "bank",
          icon: "icon-yinhangqia"
        }
      ],

      ktxje: 4826.0,
      index: 0,
      currentTab: 0,
      minPrice: 0,
      banks: [],
      commissionCount: 0,
      item: ""
    };
  },
  created() {
    let vm = this;
    bank_list({ page: 1 })
      .then(res => {
        vm.backList = res.data.data;
        vm.currentBack = vm.backList[0];
        console.log("bank_list", res);
      })
      .catch(err => {
        console.log("回调", err);
        vm.$dialog.toast({ mes: err.data.msg });
        vm.$router.push({ path: "/memmber_business" });
      });
  },
  mounted: function() {},
  methods: {
    changeBank(item) {
      let vm = this;
      vm.currentBack = item;
      vm.backShow = false;
    },

    pwdDelete() {
      let vm = this;
      vm.pwd = vm.pwd.substr(0, vm.pwd.length - 1);
    },
    pwdChange2() {
      let vm = this;

      vm.passwordShow = false;
      pay_withdraw({
        cid: vm.currentBack.id,
        money: vm.money,
        pwd: vm.pwd
      })
        .then(res => {
          vm.$dialog.toast({ mes: res.data.msg });
          vm.pwd = "";
          let cardName =
            vm.currentBack.type +
            "储蓄卡 (****" +
            vm.currentBack.card.substring(vm.currentBack.card.length - 4) +
            ")";
          setTimeout(function() {
            vm.$router.push({
              path: "/audits",
              query: { cardName: cardName, money: vm.money }
            });
          }, 500);
        })
        .catch(err => {
          vm.$dialog.alert({ mes: err.data.msg });
        });
    },
    pwdChange(val) {
      let vm = this;
      vm.pwd += val;
    },

    submits: function() {
      this.$router.push({ path: "/user/audit" });
    },
    save: function(info) {
      postCashInfo(info).then(
        res => {
          this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/audit" });
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.bt {
  color: white !important;
}

/deep/.zfmm {
  padding: 10px;
  padding-bottom: 20px;
  width: 100%;
  text-align: center;
  color: #333333;
  padding-left: 20px;
  padding-right: 20px;

  .van-field {
    background-color: #f1f1f3;
    background-color: #f1f1f3;
  }
}

.title {
  padding: 10px;

  width: 100%;
  text-align: center;
  color: #333333;
}

.carditem {
  margin-top: 15px;
}

// /deep/.van-popup--bottom{
//     background: #F2F3F5;
// }
</style>
<style type="text/css">
.tixian_buts {
  width: 92%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  background-color: #ff1900;
  margin-top: 30% !important;
  margin: 0 auto;
}

.tixian_buts button {
  color: #ffffff;
}

.tixian_trip {
  display: flex;
  align-items: center;
  color: red;
}

.tixian_input {
  font-size: 30px;
  width: 70%;
  padding-left: 10px;
}

.tixian_trip {
  margin-top: 20px;
}

.tixian_block {
  width: 92%;
  margin: 0 auto;
  border-radius: 10px;
  margin-top: -30px !important;
  background-color: #fff;
  padding: 30px 15px 30px 15px;
}

.tixian_block_img {
  margin-left: auto;
}

.tixian_block_card {
  display: flex;
  align-items: center;
  margin: 9px 0px;
}

.tixian_block_card-flex {
  flex: 1;
  padding-left: 10px;
}

.tixian_shuru {
  display: flex;
  align-items: center;
  margin-top: 15px;
  padding: 15px 0px;
  border-bottom: 1px solid #999999;
}

.tixian {
  width: 100%;
  height: 201px;
  background: linear-gradient(-88deg, #ff1900 0%, #ff6b5a 100%);
}

.tixian_price_num {
  font-size: 34px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  margin-top: 20px;
}

.trips {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.5;
  text-align: center;
}

.jiangli_top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.jiangli_top img {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 0px;
}

.jiangli_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
</style>
